import { Injectable } from '@angular/core';

import { saveAs } from 'file-saver';

import { BrowserProviderService } from './browser-provider.service';

@Injectable({
    providedIn: 'root'
})
export class DownloadService {
    static readonly bolWindowName: string = 'bol';

    constructor(private browser: BrowserProviderService) { }

    Download(blob: Blob, filename?: string): void {
        saveAs(blob, filename);
    }

    OpenInNewWindow(blob: Blob, windowName: string): void {
        const url = this.browser.createObjectURL(blob);
        this.browser.open(url, windowName);
        setTimeout(() => this.browser.revokeObjectURL(url), 300000);
    }
}
